import React from 'react';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { uniqueId } from '../../utils/helpers';
const PdpPartners = ({ data }) => {
    const wrapStyle = {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    };
    let content = null;
    if (data) {
        if (data.length > 0) {
            const partners = data.map((partner) => {
                const services = partner.services.map((service, i) => {
                    if (partner.services.length === i + 1) {
                        return service;
                    }
                    return `${service} + `;
                });
                return (React.createElement("div", { className: "pdp_partner", key: uniqueId(partner.name) },
                    React.createElement("div", { className: "partner_inner" },
                        React.createElement("div", { className: "partner_data" },
                            React.createElement("h3", null,
                                React.createElement("a", { href: `/nurseries/${partner.slug}/` }, partner.name)),
                            React.createElement("p", { className: "partner_services" }, services),
                            React.createElement("p", null, partner.address),
                            React.createElement("p", null,
                                partner.phone,
                                partner.email && (React.createElement("span", { style: wrapStyle },
                                    React.createElement("a", { href: `mailto:${partner.email}` }, partner.email)))),
                            React.createElement("p", null, partner.description && (React.createElement("span", { style: wrapStyle }, partner.description)))),
                        React.createElement("div", null,
                            React.createElement("div", { className: "available_btn" }, (partner.shop_url || partner.url) && (React.createElement("a", { href: partner.shop_url || partner.url, target: "_blank", rel: "noopener noreferrer", className: "btn primary inverted" },
                                "Check Availability",
                                ' ',
                                React.createElement(OpenInNew, { sx: { padding: 0, marginLeft: 2 } })))),
                            React.createElement("div", { className: "catalog_btn" }, partner.slug && (React.createElement("a", { href: `/nurseries/${partner.slug}`, className: "btn primary inverted" }, "Browse Catalog")))))));
            });
            content = (React.createElement("div", { className: "pdp_partners" },
                React.createElement("div", { className: "pdp_partners_container" },
                    React.createElement("h2", null, "Historical listings"),
                    React.createElement("p", { className: "subtitle" }, "We have great partners who've featured this item in the past. Check with them directly for current inventory."),
                    React.createElement("div", { className: "pdp_partner_list" }, partners))));
        }
        else {
            content = (React.createElement("div", { className: "pdp_partners" },
                React.createElement("div", { className: "pdp_partners_container" },
                    React.createElement("h2", null, "Historical listings"),
                    React.createElement("p", { className: "subtitle space-below" }, "We don't currently have any partners growing this plant."))));
        }
    }
    return content;
};
export default PdpPartners;
